import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { Container, scrollToId } from "./Primitives";

const LINKS = [
  { id: "how-it-works", label: "How It Works", testId: HOME.navHowItWorks },
  { id: "solutions", label: "Solutions", testId: HOME.navSolutions },
  { id: "organizations", label: "For Organizations", testId: HOME.navOrganizations },
];

export const Wordmark = ({ testId, className = "w-[168px] sm:w-[204px]" }) => (
  <img data-testid={testId} src="/brand/freelancai-wordmark-sm.png" alt="FreelancAI" width={807} height={128}
    className={`block h-auto ${className}`} />
);

export default function Nav() {
  const [open, setOpen] = useState(false);
  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="sticky top-0 z-40 border-b border-fg/[0.06] bg-canvas/90 backdrop-blur-xl">
      <Container className="flex h-16 items-center justify-between">
        <a href="#top" onClick={(e) => go(e, "top")} aria-label="FreelancAI home" className="rounded-sm">
          <Wordmark testId={HOME.navWordmark} />
        </a>
        <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex xl:gap-9">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={(e) => go(e, l.id)} data-testid={l.testId}
              className="fa-link rounded-sm text-[14px] text-subtle hover:text-fg">{l.label}</a>
          ))}
          <Link to="/careers" data-testid="nav-careers-link" className="fa-link rounded-sm text-[14px] text-subtle hover:text-fg">Join our AI team</Link>
        </nav>
        <div className="flex items-center gap-2">
          <a href="#assessment" onClick={(e) => go(e, "assessment")} data-testid={HOME.navCta}
            className="fa-btn hidden rounded-full border border-fg/15 px-4 py-2 text-[13px] font-medium text-fg hover:border-fg/40 sm:inline-flex">
            Start Your AI Assessment
          </a>
          <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-controls="mobile-nav"
            aria-label={open ? "Close menu" : "Open menu"} data-testid={HOME.navMenuToggle}
            className="rounded-full p-2 text-fg lg:hidden">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </Container>
      {open && (
        <nav id="mobile-nav" aria-label="Mobile" className="border-t border-fg/[0.06] lg:hidden">
          <Container className="flex flex-col py-3">
            {[...LINKS, { id: "assessment", label: "Start Your AI Assessment" }].map((l) => (
              <a key={l.id} href={`#${l.id}`} onClick={(e) => go(e, l.id)}
                className="rounded-sm py-3 text-[15px] text-subtle hover:text-fg">{l.label}</a>
            ))}
            <Link to="/careers" data-testid="mobile-nav-careers-link" className="rounded-sm py-3 text-[15px] text-subtle hover:text-fg">Join our AI team</Link>
          </Container>
        </nav>
      )}
    </header>
  );
}
